import { createContext, useContext } from 'react';

import type { IRightSection } from '../components/reusable/right-panel/utils';

export const RightSectionContext = createContext<IRightSection<{}> | null>(null);

export const useRightPanelContext = (): IRightSection<{}> => {
	const rightSectionContext = useContext(RightSectionContext);

	if (!rightSectionContext) {
		throw new Error('useGlobalContext must be used within a GlobalProvider');
		// } catch (error) {}
	}

	return {
		...rightSectionContext,
	};
};
